import { createModelSchemaWrapper } from 'framework/serializr-integration';
import { date, list, primitive } from 'serializr';

import { Severity } from 'framework/entities/healthData';
import { MonitorType } from 'areas/assets/monitors/monitorType';

export class HealthReason {
	id: string;
	timestamp: number;
	assetId: string;
	assetName: string;
	accountId: string;
	accountName: string;
	severity: Severity;
	subsystem: string;
	monitorId: string;
	monitorName: string;
	monitorType: MonitorType;
	factoryName: string;
	monitorTypeText: string;
	monitorClassText: string;
	text: string;
	externalId: string;
	externalOwner: string;
	incidentId: string;
	incidentCreated: number;
	incidentStatusId: string;
	incidentNumber: number;
	incidentAssignedToId: string;
	incidentAssignedToName: string;
	assignedToId: string;
	assignedToName: string;
	assignedToType: string;
	acknowledged: boolean;
	acknowledgedByName: string;
	acknowledgedAt: Date;
	inIncident: boolean;
	inMaintenance: boolean;
	hasEvent: boolean;
	agentId: string;
	agentName: string;
	identifierName: string;
	identifierInstance: string;
	details: string;
	dataUnavailable: boolean;
	monitorError: boolean;
	information: string;
	maintenanceDetails: string[];
	severityIndex: number;
	assigned: boolean;
}

createModelSchemaWrapper(HealthReason, {
	id: primitive(),
	timestamp: primitive(),
	assetId: primitive(),
	assetName: primitive(),
	accountId: primitive(),
	accountName: primitive(),
	severity: primitive(),
	subsystem: primitive(),
	monitorId: primitive(),
	monitorName: primitive(),
	monitorType: primitive(),
	factoryName: primitive(),
	monitorTypeText: primitive(),
	monitorClassText: primitive(),
	text: primitive(),
	externalId: primitive(),
	externalOwner: primitive(),
	incidentId: primitive(),
	incidentCreated: primitive(),
	incidentStatusId: primitive(),
	incidentNumber: primitive(),
	incidentAssignedToId: primitive(),
	incidentAssignedToName: primitive(),
	assignedToId: primitive(),
	assignedToName: primitive(),
	assignedToType: primitive(),
	acknowledged: primitive(),
	acknowledgedByName: primitive(),
	acknowledgedAt: date(),
	inIncident: primitive(),
	inMaintenance: primitive(),
	hasEvent: primitive(),
	agentId: primitive(),
	agentName: primitive(),
	identifierName: primitive(),
	identifierInstance: primitive(),
	details: primitive(),
	dataUnavailable: primitive(),
	monitorError: primitive(),
	information: primitive(),
	maintenanceDetails: list(primitive()),
	severityIndex: primitive(),
	assigned: primitive(),
});
